module.exports = __webpack_public_path__ + "static/media/btn_varejo.19916328.png";